/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DelegateDocumentRequest = {
  delegatee_email: string;
  delegatee_name: string;
  notification_preference?: DelegateDocumentRequest.notification_preference;
  /**
   * Optional list of specific RequestedFile IDs to delegate. If not provided, delegates all files.
   */
  requested_file_ids?: Array<number>;
  /**
   * Optional list of specific Question IDs to delegate from the paired questionnaire. If not provided, delegates all questions.
   */
  question_ids?: Array<number>;
};
export namespace DelegateDocumentRequest {
  export enum notification_preference {
    EACH_UPLOAD = 'each_upload',
    ALL_COMPLETE = 'all_complete',
    NONE = 'none',
  }
}

